import ContentDefaultWrapper from './contentDefaultWrapper';

export default ContentDefaultWrapper;
